import React, { useState, useRef, useEffect } from "react";
import { useNavigate, useParams, useSubmit } from 'react-router-dom';

import devuelveDependencia from '../tools/devuelveDependencia'
import * as XLSX from 'xlsx';
import './menu.css'
import { Spinner } from 'reactstrap';
import axios from 'axios';
import Modal from 'react-modal';
import { useForm } from 'react-hook-form';
import FormEditaDocente from "./formEditaDocente";
import DevuelveMaterias from './DevuelveMaterias'
import FormEditaMateria from "./formEditaMaterias";
import FormEditaCurso from "./formEditaCurso";
import DevuelveDocentes from "./DevuelveDocentes";
import { CSVLink } from "react-csv";
import ModuloDevuelveInasistenciasDocentes from "./DevuelveInasistenciasDocentes";
import { ordeno } from "../tools/ordenaArrayDeObjetos";
import { addDays } from 'date-fns';
import devuelveSedeConsultada from '../tools/devuelveSede';
import CargaMasiva from "./CargaMasivaLector";
import regresaBienFechaYDia from "../tools/regresaBienFechayDia";
import DocenteBuscadorActivo from "./DocenteBuscadorActivo";
import ModalNew from "./ModalNew";
import DivisionesSelector from "./DivisionSelector";
import Swal from 'sweetalert2'
import DocenteBuscadorGlobal from "./DocenteBuscadorGlobal";
import comprueboPermisos from "../tools/comprueboPermisos";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ObtieneDatosCookies from "../obtieneDatosCookiesUsuario";
import DocentesPorMateriaTabla from "./DocentesPorMateriaTabla";
import DocentesPorMateriaTablaAsignacion from "./DocentesPorMateriaTablaAsignacion";
import socket from "../tools/socke";
import SincronizaMoodle from "./SincronizaMoodle";
import ReporteAsistenciaDocentes from "./ReporteAsistenciaDocentes";
import InformeAusenciasDocentes from "./InformeAusenciasDocentes";
import ModuloAvisosAusenciasDocentes from "./ModuloAvisosAusenciasDocentes";
import ModuloCreaIncunvenciaDocentes from "./ModuloCreaIncunvenciaDocentes";

function Docentes() {
  const sedes = devuelveSedeConsultada()
  let fecha = new Date()
  const Usuario = ObtieneDatosCookies() || {};

  const obtenerDescripcionDependencia = () => {
    try {
      // Primero usamos el nombre que ya viene guardado en la sesión.
      if (Usuario?.dependenciaNombre) {
        return Usuario.dependenciaNombre;
      }

      const dependencias = devuelveDependencia();

      if (!Array.isArray(dependencias)) {
        return Usuario?.destino
          ? `Destino ${Usuario.destino}`
          : "Dependencia sin definir";
      }

      const dependenciaEncontrada = dependencias.find(
        (dependencia) =>
          String(dependencia?.id ?? "").trim() ===
          String(Usuario?.destino ?? "").trim()
      );

      return (
        dependenciaEncontrada?.descripcion ||
        (Usuario?.destino
          ? `Destino ${Usuario.destino}`
          : "Dependencia sin definir")
      );
    } catch (error) {
      console.error("Error obteniendo la dependencia del usuario:", error);

      return Usuario?.destino
        ? `Destino ${Usuario.destino}`
        : "Dependencia sin definir";
    }
  };

  const descripcionDependencia = obtenerDescripcionDependencia();


  const printRef = useRef();
  const [fechaDesde, setFechaDesde] = useState(null);
  const [fechaHasta, setFechaHasta] = useState(null);
  const horasMaximasDocenteCivil = 36;
  const horasMaximasDocenteRetirado = 10;
  const horasMaximasDocenteEnActividad = 12;
  const [spinnerModal, setSpinnerModal] = useState(false)
  const [sedeLector, setSedeLector] = useState("Rosario")
  const [modalHorasIsOpen, setHorasIsOpen] = useState(false);
  const [veoCargaLector, setVeoCargaLector] = useState(false)
  const [NominaFull, setNominaFull] = useState([])
  const [mostrarMoodle, setMostrarMoodle] = useState(false)
  const [veoModalMauri, setVeoModalMauri] = useState(false)
  const [veoModalAvisos, setVeoModalAvisos] = useState(false)
  const [veoModalCreaIncunvencia, setVeoModalCreaIncunvencia] = useState(false)
  const [veoModalSeleccionDocente, setVeoModalSeleccionDocente] = useState(false)
  const [modalControlLectorIsOpen, setControlLectorIsOpen] = useState(false)
  const [modalDocentesIsOpen, setDocentesIsOpen] = useState(false);
  const [docenteObtenidoModal, setdocenteObtenidoModal] = useState(false)
  const [escuelaSeleccionadaFiltro, setEscuelaSeleccionadaFiltro] = useState([])
  const [modalInformeDocenteIsOpen, setmodalInformeDocenteIsOpen] = useState(false);
  const [mostrarEditaMateria, setEditaMateria] = useState(false);
  const [mostrarEditaCurso, setEditaCurso] = useState(false);
  const [cuerpoDocente, setCuerpoDocente] = useState({})
  const [cargando, setCargando] = useState(false);
  const [docenteSeleccionado, setDocenteSeleccionado] = useState(false)
  const [crearDocente, setCrearDocente] = useState(false)
  const [muestraDocente, setMuestaDocente] = useState(false)
  const [escuelaSeleccionada, setEscuelaSeleccionada] = useState(false);
  const [materiasDevueltas, setMateriasDevueltas] = useState(false);
  const [infoMateriasDevueltas, setInfoMateriasDevueltas] = useState(false);
  const [mostrarMateriasDevueltas, setMostrarMateriasDevueltas] = useState(false);
  const [cursosSeteados, setCursosSeteados] = useState(false)
  const [mostrarCursos, setMostrarCursos] = useState(false)
  const [nominaDocente, setNominaDocente] = useState([])
  const [ausenciasDocentes, setAusenciasDocentes] = useState(null)
  const [modalInformeInasistenciasDocenteIsOpen, setModalInformeInasistenciasDocenteIsOpen] = useState(false)

const [cursoSeleccionado, setCursoSeleccionado] = useState(null);
const [modoCurso, setModoCurso] = useState("crear");
const [modalEditarCursosIsOpen, setModalEditarCursosIsOpen] = useState(false);



  const [datosMateriaElegida, setDatosMateriaElegida] = useState()
  const [veoModalSeleccionDivisiones, setveoModalSeleccionDivisiones] = useState(false)
  const [divisionesElegidas, setdivisionesElegidas] = useState()

  const CursosDisponibles = async (escuela) => {

    const client = axios.create({

      baseURL: process.env.REACT_APP_BASEURL + "cursos/devuelveCursosPorEscuela/"
    });
    try {
      const docente = await client.post('/' + escuela, { "estadoCurso": "Activo" })
      if (docente.data) {

        return docente.data
      }

    }
    catch (error) { }
  }


  const navitate = useNavigate()

  function openModalDocentes() {
    setDocentesIsOpen(true);
  }
  const mapeaLasHoras = (dato) => {
    var horasdeesteDocente = []
    if (Array.isArray(dato) && dato.every(item => typeof item === 'object' && item !== null)) {
      dato.map((valor) =>
        horasdeesteDocente.push()
      );
    } else {
      console.warn("El dato proporcionado no es un array de objetos.");
    }
  };

  function closeModalDocentes() {

    setDocentesIsOpen(false);
    setDocenteSeleccionado(null)


  }
  const [DatosMaterias, setDatosMaterias] = useState(null)
  const devuelveAllMaterias = async () => {
    const client = axios.create({

      baseURL: process.env.REACT_APP_BASEURL + "materias/devuelveAllMaterias"
    });
    try {

      const datos = await client.post('/')
      if (datos) {
        setDatosMaterias(datos.data)
        return datos.data
      }
    }

    catch { }
  }

  function openModalHoras() {
    setHorasIsOpen(true);
  }


  function closeModalEditaMateria() {
    setEditaMateria(false);

  }
  function closeModalInformeDocentes() {
    setmodalInformeDocenteIsOpen(false);

  }
  const openModalInformeDocente = async () => {
    setSpinnerModal(true)
    const client = axios.create({

      baseURL: process.env.REACT_APP_BASEURL + "docentes/devuelveDocentes"
    });
    try {
      const docente = await client.post('/')
      if (docente) {
        setCuerpoDocente(docente.data)


        const devuelveHoras = (index) => {


          const horasDocente = Array.isArray(docente?.data?.Horas?.[index])
            ? docente.data.Horas[index]
            : [];

          if (horasDocente.length > 0) {
            var HorasTotales = 0
            var Horas = []
            for (var i = 0; i < horasDocente.length; i++) {
              Horas.push(horasDocente[i])
              HorasTotales += Number(horasDocente[i]?.horasAsignadas || 0)
            }
            const variable = [HorasTotales, Horas]
            return (variable)

          } else {
            return "Sin horas"
          }

        }
        var docentes = []


        const listaDocentes = Array.isArray(docente?.data?.Docente)
          ? docente.data.Docente
          : [];

        for (let index = 0; index < listaDocentes.length; index++) {
          const docentex = listaDocentes[index]
          const cc = devuelveHoras(index)
          docentex.HorasCatedrasTotales = Array.isArray(cc) ? cc[0] : 0
          docentex.HorasQueTiene = Array.isArray(cc) ? cc[1] : []



          docentes.push(docentex)

        }
        ordeno(docentes, "docenteApellido")
        setNominaDocente(docentes)

        setmodalInformeDocenteIsOpen(true)
        setSpinnerModal(false)

      }
      else {
        setSpinnerModal(false)
      }
    }
    catch (error) { }

  }


  function closeModalHoras() {
    setHorasIsOpen(false);

  }



  const ExisteDocente = async (info) => {
    setDocenteSeleccionado(null)
    const client = axios.create({

      baseURL: process.env.REACT_APP_BASEURL + "docentes/devuelveDocente"
    });
    try {
      const docente = await client.post('/' + info)
      if (docente?.data?.docente?.[0]) {

        setDocenteSeleccionado(docente.data)
        setCrearDocente(false)
        setMuestaDocente(true)

      } else {

        seteadoDocente(null)
        setMuestaDocente(false)

      }
    }
    catch (error) { }

  }
  const seteadoDocente = async (docente) => {

  }

  const { register, formState: { errors }, handleSubmit, } = useForm({
    defaultValues: {}
  });





  const headerInasistencias = [
    { label: "Nro Control", key: "id" },
    { label: "Docente", key: "docente" },
    { label: "DNI", key: "docenteDni" },
    { label: "Motivo", key: "motivo" },
    { label: "Escuela", key: "escuela" },
    { label: "Curso", key: "curso" },
    { label: "Materia", key: "materia" },
    { label: "Sede Cursada", key: "sedeCursada" },
    { label: "Division", key: "division" },
    { label: "Fecha de Inasistencia", key: "fechaInasistencia" },
    { label: "Devolvio", key: "devolvioInasistencia" }





  ];

  const volver = () => {
    navitate('/usuarioLogueado')
  }

  const consultaDocente = (data) => {

    ExisteDocente(data.docenteDni)
  }
  const seteaEscuela = async (dato) => {
    setEditaCurso(false)
    setModalEditarCursosIsOpen(false)
    setEscuelaSeleccionada(dato)
    muestroEdita("")

    const client = axios.create({

      baseURL: process.env.REACT_APP_BASEURL + "materias/devuelveMateriaPorEscuela"
    });
    try {

      const Materias = await client.post('/' + dato, { "estadoMateria": "Activo" })
      const cursosDisponibles = await CursosDisponibles(dato)
      if (cursosDisponibles != null) {

        setCursosSeteados(cursosDisponibles)

        setMostrarCursos(true)
      }
      if (Array.isArray(Materias?.data?.Materia) && Materias.data.Materia.length > 0) {


        setMateriasDevueltas(Materias.data)

        setMostrarMateriasDevueltas(true)


      } else {

        setMateriasDevueltas(null)
        setMostrarMateriasDevueltas(false)
      }
    }
    catch (error) { }

  }


  const elijoDocente = (infoTotal) => {
    setDatosMateriaElegida(infoTotal)
    setVeoModalSeleccionDocente(true)


  }
  const ahoraVerifico = (docenteObtenido) => {

    setVeoModalSeleccionDocente(false)
    setdocenteObtenidoModal(docenteObtenido)
    verificoMateria(datosMateriaElegida, docenteObtenido)

  }

  const verificoMateria = async (materia, docente) => {

    try {



      if (materia && docente) {



        consultarDocenteAsignaMateria(docente, materia)

      }

      else {

        setMateriasDevueltas(null)
        setMostrarMateriasDevueltas(false)

      }
    }
    catch (error) { }

  }

  const consultarDocenteAsignaMateria = async (Docente, materia) => {
    const infoConsulta = {
      "docenteDni": Docente.docenteDni,
      "fechaMaximaInicio": materia.fechaInicio,
      "fechaMaximaFinalizacion": materia.fechaFinalizacion
    }

    const client = axios.create({

      baseURL: process.env.REACT_APP_BASEURL + "docentes/puedeDarHoras"
    });
    try {

      const resultadoConsulta = await client.post('/', infoConsulta)

      if (resultadoConsulta.data.docente == "") {

        const entonces = window.confirm("Docente Inexistente en el sistema, gestionelo!!!!!")
        if (entonces) {
          closeModalHoras()
          setDocentesIsOpen(true)

        }
      }
      else {
        /*
         var horasMaximas = 0;
         if (resultadoConsulta.data.docente[0].docenteTipo == "Policia Actividad") {
           horasMaximas = horasMaximasDocenteEnActividad
         } else if (resultadoConsulta.data.docente[0].docenteTipo == "Policia Retirado") {
           horasMaximas = horasMaximasDocenteRetirado
         } else {
           horasMaximas = horasMaximasDocenteCivil
         }
         if (resultadoConsulta.data.horas < horasMaximas && resultadoConsulta.data.docente[0].docenteEstado == "Activo") {
         
           const horasDisponibles = horasMaximas - resultadoConsulta.data.horas
         
           if (horasDisponibles >= materia.bloqueHorario) {*/
        asignoMateria(resultadoConsulta.data, materia)




      }


    }
    catch (error) { }




  }

  const asignoMateria = async (info, materia) => {


    const devuelveDivisionesLibres = async (divSolicitada) => {

      const client = axios.create({

        baseURL: process.env.REACT_APP_BASEURL + "materias/devuelveMateriaDivisionesLibres"
      });
      try {

        const DivisionesLibres = await client.post('/', { "Materia": [divSolicitada] })


        return DivisionesLibres.data

      }
      catch (error) { }
    }

    const divisiones = await devuelveDivisionesLibres(materia)

    if (Array.isArray(divisiones?.Libres) && divisiones.Libres.length > 0) {
      setdivisionesElegidas(divisiones)
      setveoModalSeleccionDivisiones(true)






    }
    else { alert("Se acabaron") }

  }

  const crearAulasMoodle = () => {
    setEditaCurso(false);
    setEditaMateria(false);
    setModalEditarCursosIsOpen(false);
    setMostrarMoodle(true);
  }

  const crearMaterias = () => {
    setEditaCurso(false);
    setMostrarMoodle(false);
    setModalEditarCursosIsOpen(false);
    setEditaMateria(true);
  }

  const abrirModalEditarCursos = () => {
    setEditaCurso(false);
    setEditaMateria(false);
    setMostrarMoodle(false);
    setCursoSeleccionado(null);
    setModoCurso("editar");
    setModalEditarCursosIsOpen(true);
  };

const editarCurso = (curso) => {
  setCursoSeleccionado(curso);
  setModoCurso("editar");

  setEditaMateria(false);
  setMostrarMoodle(false);
  setModalEditarCursosIsOpen(false);
  setEditaCurso(true);
};

const crearCurso = () => {
  setCursoSeleccionado(null);
  setModoCurso("crear");

  setEditaMateria(false);
  setMostrarMoodle(false);
  setModalEditarCursosIsOpen(false);
  setEditaCurso(true);
};

  const muestroEdita = (dato) => {
    setEditaMateria(false)

  }
  const resetForm = () => {

    setDocenteSeleccionado(null)
    document.getElementById("consulta-dni-docente").reset();
    setCrearDocente(false)
  }
  const definoCrear = () => {
    setCrearDocente(!crearDocente)
  }
  const restaDias = (cantidad) => {
    const fechaOrigen = new Date()

    return addDays(fechaOrigen, -cantidad)
  }
  const funcionMauri = (fecha) => { 
    
    setVeoModalMauri(true)


  }
  const informaInasistencias = async (fecha1, fecha2) => {

    function sortArrayByAttribute(arr, attribute) {
      return arr.sort((a, b) => {
        if (a[attribute] < b[attribute]) {
          return -1;
        }
        if (a[attribute] > b[attribute]) {
          return 1;
        }
        return 0;
      });
    }


    setSpinnerModal(true)

    setModalInformeInasistenciasDocenteIsOpen(false)
    function filtro(inasistenciasPasadas) {
      if (Usuario.destino == "1" || Usuario.destino == "7" || Usuario.destino == "45" || Usuario.destino == "10" || comprueboPermisos(Usuario.funcion, "Veo inasistencia docente")) {
        setAusenciasDocentes(inasistenciasPasadas)
      }
      else if (Usuario.destino == "11") {
        setAusenciasDocentes(inasistenciasPasadas.filter(x => x.escuela == "Educacion a Distancia"))
      }
      else if (Usuario.destino == "12" || Usuario.destino == "16" || Usuario.destino == "25") {
        setAusenciasDocentes(inasistenciasPasadas.filter(x => x.escuela == "Escuela de Policia"))
      }
      else if (Usuario.destino == "13" || Usuario.destino == "17" || Usuario.destino == "26" || Usuario.destino == "56") {
        setAusenciasDocentes(inasistenciasPasadas.filter(x => x.escuela == "Escuela Superior"))
      }
      else if (Usuario.destino == "14" || Usuario.destino == "18" || Usuario.destino == "27" || Usuario.destino == "34") {
        setAusenciasDocentes(inasistenciasPasadas.filter(x => x.escuela == "Escuela de Especialidades"))
      }
      else if (Usuario.destino == "15" || Usuario.destino == "19" || Usuario.destino == "28") {
        setAusenciasDocentes(inasistenciasPasadas.filter(x => x.escuela == "Escuela de Investigaciones"))
      }
      setModalInformeInasistenciasDocenteIsOpen(true)
      setSpinnerModal(false)
    }
    function formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Los meses en JS son 0-indexados
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    }

    let fechaHoy = fecha

    let hace30Dias = new Date(fecha)
    let fechaInicial = hace30Dias.setDate(fecha.getDate() - 15);
    let fechaa = new Date(fechaInicial)
    const manana = addDays(fechaHoy, 1);

    if (fecha1 && fecha2) {//si me consulta fechas devuelvo, sino por defecto los ultimos 30 dias
      try {
        const client = axios.create({

          baseURL: process.env.REACT_APP_BASEURL + "docentes/devuelveInasistencias"
        });

        const e = await client.post('/' + "?fechaInicial=" + fecha1 + "&fechaFinal=" + fecha2)
        if (e) {
//           console.log(e)
          sortArrayByAttribute(e.data, "fechaInasistencia")
          filtro(e.data)
        }
      } catch { }
    } else {
      try {
        const clientw = axios.create({

          baseURL: process.env.REACT_APP_BASEURL + "docentes/devuelveInasistencias"
        });


        const d = await clientw.post('/' + "?fechaInicial=" + formatDate(fechaa) + "&fechaFinal=" + manana)
        if (d) {

          sortArrayByAttribute(d.data, "fechaInasistencia")

          filtro(d.data)
        }
      } catch { }
    }
  }


  const customStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      width: "auto",
      height: "auto"

    },
  };
  
const customStylesMauri = {
  content: {
    top: '1vh',
    left: '1vw',
    right: '1vw',
    bottom: '1vh',

    width: '98vw',
    height: '98vh',

    maxWidth: 'none',
    maxHeight: 'none',

    margin: 0,

    borderRadius: '10px',
    border: 'none',

    padding: '30px',

    overflow: 'auto',

    backgroundColor: '#ffffff',

    boxSizing: 'border-box',
  },

  overlay: {
    zIndex: 9999,
    backgroundColor: 'rgba(0, 0, 0, 0.55)',
  },
};


  const customStylesDocentes = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      maxWidth: '90%',
      maxHeight: '90%',
      width: 'auto',
      height: 'auto',
      overflow: 'auto'

    },
  };

  const customStylesInasistencias = {

    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      maxWidth: '90%',
      maxHeight: '90%',
      width: 'auto',
      height: 'auto',
      overflow: 'auto'
    },
  };

  const customStylesGestion = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      width: '95%',
      maxWidth: '1100px',
      maxHeight: '90vh',
      overflow: 'auto',
      padding: '0',
      borderRadius: '10px',
    },
    overlay: {
      zIndex: 9999,
      backgroundColor: 'rgba(0, 0, 0, 0.55)',
    },
  };

  const cerrarModalCurso = () => {
    setEditaCurso(false);
    setCursoSeleccionado(null);
    setModoCurso("crear");
  };

  const cerrarModalMateria = () => {
    setEditaMateria(false);
  };

  const cerrarModalListaCursos = () => {
    setModalEditarCursosIsOpen(false);
    setCursoSeleccionado(null);
    setModoCurso("crear");
  };

  const cerrarModalMoodle = () => {
    setMostrarMoodle(false);
  };

  const refrescarGestionEscuela = (escuelaDevuelta) => {
    const escuela = escuelaSeleccionada || escuelaDevuelta;

    if (escuela) {
      seteaEscuela(escuela);
    }

    cerrarModalCurso();
    cerrarModalMateria();
    cerrarModalListaCursos();
    cerrarModalMoodle();
  };

  const ModalGestionHeader = ({ titulo, subtitulo, onClose }) => (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: "10px",
        padding: "12px 16px",
        borderBottom: "1px solid #ddd",
        background: "#f8f9fa",
        position: "sticky",
        top: 0,
        zIndex: 2,
      }}
    >
      <div>
        <strong style={{ fontSize: "16px" }}>{titulo}</strong>
        {subtitulo ? (
          <div style={{ fontSize: "12px", color: "#666" }}>{subtitulo}</div>
        ) : null}
      </div>

      <button className="btn btn-danger btn-sm" onClick={onClose}>
        ×
      </button>
    </div>
  );

  const ordenoLasAusencias = async (array, propiedad) => {
    setModalInformeInasistenciasDocenteIsOpen(false)
    const nuevo = await ordeno(array, propiedad)
    setAusenciasDocentes(nuevo)
    setModalInformeInasistenciasDocenteIsOpen(true)
  }
  const seteaListaInasistenciasFinal = () => {

  }
  const headersNominaFull = [
    { label: "Nro Control", key: "Nro Control" },
    { label: "Apellido", key: "Apellido" },
    { label: "Nombres", key: "Nombres" },
    { label: "DNI", key: "DNI" },
    { label: "Materia", key: "Materia" },
    { label: "Escuela", key: "Escuela" },
    { label: "Sede", key: "Sede" },
    { label: "Horas Totales", key: "Horas Totales" }



  ];
  const devuelveHorasLibresDocente = (docente) => {

    let maxHoras = 0;
    switch (docente.docenteTipo) {
      case "Policia Actividad":
        maxHoras = 12;
        break;
      case "Personal Civil":
        maxHoras = 36;
        break;
      default:
        maxHoras = 10;
        break;
    }


    let horasOcupadas = 0;
    if (Array.isArray(docente.asignacionMaterias)) {
      docente.asignacionMaterias.forEach((asignacion) => {
        if (asignacion.materia && asignacion.materia.bloqueHorario) {
          horasOcupadas += asignacion.materia.bloqueHorario;
        }
      });
    }


    const horasLibres = maxHoras - horasOcupadas;

    return horasLibres >= 0 ? horasLibres : 0;
  };
  const creaListaDocenteDirector = async () => {
//     console.log(nominaDocente)
    const eliminarDuplicadosPorIdMateria = (array) => {
      // Verifica si el array está vacío
      if (!Array.isArray(array) || array.length === 0) {
        return [];
      }

      // Crea un Map para almacenar objetos únicos por idMateria
      const mapaUnicos = new Map();

      array.forEach(item => {
        // Solo agrega el primer objeto con un idMateria específico
        if (!mapaUnicos.has(item.idMateria)) {
          mapaUnicos.set(item.idMateria, item);
        }
      });

      // Devuelve los valores únicos del mapa como un nuevo array
      return Array.from(mapaUnicos.values());
    };









    const DatosMaterias = await devuelveAllMaterias()
    var DocentesNuevos = []
    nominaDocente.map((esteDocente) => {
      const arraySinDuplicados = eliminarDuplicadosPorIdMateria(esteDocente.HorasQueTiene);
      arraySinDuplicados.forEach(element => {


        var DocenteCreado = {
          "Nro Control": esteDocente.id,
          "Apellido": esteDocente.docenteApellido,
          "Nombres": esteDocente.docenteNombres,
          "DNI": esteDocente.docenteDni,
          "Materia": DatosMaterias?.materias?.find(x => x.id == element.idMateria)?.nombreMateria || "-",
          "Escuela": DatosMaterias?.materias?.find(x => x.id == element.idMateria)?.escuela || "-",
          "Sede": element.sedeCursada,
          "Horas Totales": esteDocente.HorasCatedrasTotales
        }
        DocentesNuevos.push(DocenteCreado)
      });

    })








    setNominaFull(DocentesNuevos)
    dale()
  }
  const dale = () => {
    alert("Si")

  }
  const asignaHoras = async (dato) => {
    const client = axios.create({
      baseURL: process.env.REACT_APP_BASEURL + "materias/asignaMateria"
    });

    for (let i = 0; i < dato.divisiones.length; i++) {
      const division = dato.divisiones[i];
      const asignacionADocente = {
        idMateria: datosMateriaElegida.id,
        sedeCursada: dato.sedeCursada, // ⚡ usar la sede elegida
        division: division,
        docenteDni: docenteObtenidoModal.docenteDni,
        horasAsignadas: datosMateriaElegida.bloqueHorario,
        fechaInicio: datosMateriaElegida.fechaInicio,
        fechaFinalizacion: datosMateriaElegida.fechaFinalizacion,
        usuarioID: Usuario.id,
        sedeID: Usuario.sedeID,
        dependenciaID: Usuario.destino,
        esRentada: "SI",
        estado: "Activo",
        condicion: "Ofrecida"
      };

      try {

        const d = await client.post('/', asignacionADocente);
        if (d.status === 200 || d.status === 201) {
//           console.log(`Asignación exitosa para división ${division}`);
//           console.log(`Asignación exitosa para división ${asignacionADocente}`);
          socket.emit("ofreciHoras", { dato: asignacionADocente })
        }
      } catch (error) {
        console.error(`Error al asignar la división ${division}:`, error);
      }
    }

    seteaEscuela(escuelaSeleccionada);
    Swal.fire("✅ Asignación creada", "La asignación fue completada sin novedad!", "success");
    devuelveAllMaterias();
    setveoModalSeleccionDivisiones(false);
  }





  function transformDataToExcelFormat(data) {
    const rows = [];

    const docentes = Array.isArray(data?.respuesta) ? data.respuesta : [];

    docentes.forEach(docente => {

      const baseRow = {
        docenteApellido: docente.docenteApellido || '',
        docenteNombres: docente.docenteNombres || '',
        docenteDni: docente.docenteDni || '',
        docenteTipo: docente.docenteTipo || '',

      };

      if (docente.asignacionMaterias && docente.asignacionMaterias.length > 0) {
        docente.asignacionMaterias.forEach(hora => {
          rows.push({
            ...baseRow,
            Division: hora.division || '-',
            Materia: hora?.materia?.nombreMateria || '-',
            SedeCursada: hora?.sedeCursada || '-',
            Escuela: hora?.materia?.escuela || '-',
            Horas: hora?.materia?.bloqueHorario || '-',
            HorasDisponibleDocente: devuelveHorasLibresDocente(docente),
          });
        });
      } else {
        rows.push({
          ...baseRow,
          Division: '-',
          Materia: '-',
          SedeCursada: '-',
          Escuela: '-',
          Horas: '-',
          HorasDisponibleDocente: devuelveHorasLibresDocente(docente),
        });
      }
    });

    return rows;
  }

  function exportToExcel(data, fileName = 'docentes_' + fecha.toLocaleDateString() + '.xlsx') {
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Docentes');
    XLSX.writeFile(workbook, fileName);
  }


  async function exportDocentesExcel(inicio = null, fin = null) {
    Swal.fire({
      title: 'Cargando docentes...',
      text: 'Por favor espere',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
      timer: 30000,
      timerProgressBar: true
    });

    const client = axios.create({
      baseURL: process.env.REACT_APP_BASEURL + "docentes/devuelveTodosLosDocentesActivosMateriasVigentes/"
    });

    try {
      // Armamos el body del POST
      const body = {};
      if (inicio && fin) {
        body.inicio = inicio;
        body.fin = fin;
      }

      const response = await client.post('/', body);
      const data = response.data;

      if (!data || !data.respuesta) {
        Swal.close();
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se encontraron datos de docentes',
          timer: 3000,
          showConfirmButton: false
        });
        return;
      }

      // Transformar datos
      const rows = data.respuesta.map(docente => {
        const baseRow = {
          docenteApellido: docente.docenteApellido || '',
          docenteNombres: docente.docenteNombres || '',
          docenteDni: docente.docenteDni || '',
          docenteTipo: docente.docenteTipo || '',
        };

        let asignacionesStr = '';
        let totalHorasAsignadas = 0;

        if (docente.asignacionMaterias && docente.asignacionMaterias.length > 0) {
          docente.asignacionMaterias.forEach(hora => {
            const horas = hora?.materia?.bloqueHorario || 0;
            totalHorasAsignadas += Number(horas);
            const materiaNombre = hora?.materia?.nombreMateria || '-';
            const division = hora.division || '-';
            asignacionesStr += `${materiaNombre} (${division}): ${horas} hs
`;
          });
          asignacionesStr = asignacionesStr.trim();
        } else {
          asignacionesStr = '-';
        }

        let maxHoras = 0;
        switch (docente.docenteTipo) {
          case 'Policia Actividad':
            maxHoras = 12;
            break;
          case 'Civil':
            maxHoras = 36;
            break;
          case 'Policia Retirado':
            maxHoras = 10;
            break;
          default:
            maxHoras = 0;
        }

        const horasLibres = maxHoras - totalHorasAsignadas;

        return {
          ...baseRow,
          Asignaciones: asignacionesStr,
          HorasAsignadas: totalHorasAsignadas,
          HorasLibres: horasLibres >= 0 ? horasLibres : 0,
        };
      });

      // Mostrar alerta de generación de archivo
      Swal.fire({
        title: 'Generando archivo Excel...',
        text: 'Espere un momento',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      const fecha = new Date();
      const fileName = `docentes_${fecha.toLocaleDateString()}.xlsx`;

      const worksheet = XLSX.utils.json_to_sheet(rows);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Docentes');
      XLSX.writeFile(workbook, fileName);

      Swal.fire({
        icon: 'success',
        title: '¡Listo!',
        text: 'El archivo Excel se descargó correctamente',
        timer: 2000,
        showConfirmButton: false
      });

    } catch (error) {
      Swal.close();
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Hubo un problema al generar el Excel',
        timer: 3000,
        showConfirmButton: false
      });
      console.error(error);
    }
  }




  const TraemeTodosLosDocentes = async () => {

    const client = axios.create({

      baseURL: process.env.REACT_APP_BASEURL + "docentes/devuelveTodosLosDocentesActivos/"
    });
    try {
      const docente = await client.post('/')
      if (docente) {

//         console.log(docente)
        const excelData = transformDataToExcelFormat(docente.data);

        exportToExcel(excelData);
      } else {


      }
    }
    catch (error) { }

  }

  const ejecuto = () => {
    TraemeTodosLosDocentes()
  }

  const buttonText =
    fechaDesde && fechaHasta ? "Consultar periodo" : "Consultar periodo actual";
const [fechaInicioInforme, setFechaInicioInforme] = useState(restaDias(15));
const [fechaFinalInforme, setFechaFinalInforme] = useState(restaDias(-1));

const cerrarModalInformeInasistencias = () => {
  setModalInformeInasistenciasDocenteIsOpen(false);
};

const consultarInformeInasistencias = () => {
  if (!fechaInicioInforme || !fechaFinalInforme) {
    alert("Debe seleccionar una fecha de inicio y una fecha final.");
    return;
  }

  if (fechaInicioInforme > fechaFinalInforme) {
    alert("La fecha de inicio no puede ser posterior a la fecha final.");
    return;
  }

  informaInasistencias(fechaInicioInforme, fechaFinalInforme);
};

const consultarPeriodoInasistencias = (dias) => {
  const nuevaFechaInicio = restaDias(dias);
  const nuevaFechaFinal = restaDias(-1);

  setFechaInicioInforme(nuevaFechaInicio);
  setFechaFinalInforme(nuevaFechaFinal);

  informaInasistencias(nuevaFechaInicio, nuevaFechaFinal);
};

const periodosInasistencias = [
  {
    texto: "Últimos 7 días",
    dias: 7,
  },
  {
    texto: "Últimos 15 días",
    dias: 15,
  },
  {
    texto: "Últimos 30 días",
    dias: 30,
  },
  {
    texto: "Últimos 3 meses",
    dias: 90,
  },
  {
    texto: "Últimos 6 meses",
    dias: 180,
  },
  {
    texto: "Último año",
    dias: 365,
  },
];
  return (
    <div className="modulo-docentes">
      <Modal
        isOpen={spinnerModal}

        onRequestClose={closeModalInformeDocentes}
        style={customStyles}
        ariaHideApp={false}
      >Cargando Docentes...<Spinner>

        </Spinner>
      </Modal>
      <Modal
        isOpen={modalControlLectorIsOpen}

        onRequestClose={() => setControlLectorIsOpen(false)}
        style={customStyles}
        ariaHideApp={false}
      >
        <div className=" btn-group"> <button className="btn btn-danger" style={{ display: "flex", alignContent: "flex-end" }} onClick={() => setControlLectorIsOpen(false)}>x </button> <a style={{ alignSelf: "center" }}><strong>Control Lector. </strong></a>



        </div>


        <div style={{ overflow: "auto", height: "550px", width: "950px" }}>
          {Usuario.destino == "1" || Usuario.destino == "7" ? <> </> : ""}

          <CargaMasiva sede={sedeLector} escuelaSeleccionada={"Escuela de Policia"} />
        </div>
      </Modal>





      <Modal
        isOpen={modalInformeDocenteIsOpen}

        onRequestClose={closeModalInformeDocentes}
        style={customStylesDocentes}
        ariaHideApp={false}
      >
        <div className=" btn-group"> <button className="btn btn-danger" style={{ display: "flex", alignContent: "flex-end" }} onClick={closeModalInformeDocentes}>x </button> <a style={{ alignSelf: "center" }}><strong>Informe Docente. </strong>Cantidad de Docentes:{" " + nominaDocente ? nominaDocente.length : ""}</a>




        </div>


        <div style={{ overflow: "auto", height: "350px", width: "auto" }}>

          <DevuelveDocentes Docentes={nominaDocente} />


        </div>
      </Modal>
      <Modal
        isOpen={modalInformeDocenteIsOpen}

        onRequestClose={closeModalInformeDocentes}
        style={customStyles}
        ariaHideApp={false}
      ><div ref={printRef} style={{ padding: '20px', border: '1px solid black', marginBottom: '20px' }}>
          <div className=" btn-group"> <button className="btn btn-danger" style={{ display: "flex", alignContent: "flex-end" }} onClick={closeModalInformeDocentes}>x </button> <a style={{ alignSelf: "center" }}><strong>Informe Docente. </strong>Cantidad de Docentes:{" " + nominaDocente ? nominaDocente.length : ""}</a>

            {Usuario.destino == 7 || Usuario.destino == 1 ?
              <>{
                comprueboPermisos(Usuario.funcion, "Descargo Nomina Docente con horas vigentes") ?
                  <>
                    <div style={{ display: "flex", gap: "10px", marginBottom: "10px" }}>
                      <DatePicker
                        selected={fechaDesde}
                        onChange={(date) => setFechaDesde(date)}
                        selectsStart
                        startDate={fechaDesde}
                        endDate={fechaHasta}
                        placeholderText="Fecha desde"
                        dateFormat="dd/MM/yyyy"
                      />
                      <DatePicker
                        selected={fechaHasta}
                        onChange={(date) => setFechaHasta(date)}
                        selectsEnd
                        startDate={fechaDesde}
                        endDate={fechaHasta}
                        minDate={fechaDesde} // evita elegir una fecha menor
                        placeholderText="Fecha hasta"
                        dateFormat="dd/MM/yyyy"
                      />
                    </div>

                    <button onClick={exportDocentesExcel}>{buttonText}</button>
                  </> : ""}

                <button className="btn btn-success" style={{ marginLeft: "10px" }} onClick={() => {
                  ejecuto()

                }}>Descargar</button> </> : ""}


          </div>

          <div style={{ overflowY: 'auto', maxHeight: '60vh' }} >


            <DevuelveDocentes Docentes={nominaDocente} />


          </div></div>
      </Modal>

<Modal
  isOpen={modalInformeInasistenciasDocenteIsOpen}
  onRequestClose={cerrarModalInformeInasistencias}

  ariaHideApp={false}
  contentLabel="Informe de inasistencias docentes"
>
  <section className="informe-inasistencias-modal">
    <header className="informe-inasistencias-modal__header">
      <div>
        <span className="informe-inasistencias-modal__eyebrow">
          Gestión docente
        </span>

        <h3 className="informe-inasistencias-modal__title">
          Informe de inasistencias docentes
        </h3>

        <p className="informe-inasistencias-modal__description">
          Consulte, ordene y descargue las inasistencias registradas.
        </p>
      </div>

      <div className="informe-inasistencias-modal__header-actions">
        <CSVLink
          data={ausenciasDocentes || []}
          headers={headerInasistencias}
          filename="Informe Inasistencias Docentes.csv"
          separator=";"
          target="_blank"
          className="btn btn-success"
          onClick={() => {
            seteaListaInasistenciasFinal();
          }}
        >
          Descargar CSV
        </CSVLink>

        <button
          type="button"
          className="btn btn-outline-danger"
          onClick={cerrarModalInformeInasistencias}
          aria-label="Cerrar informe"
          title="Cerrar"
        >
          ×
        </button>
      </div>
    </header>

    <div className="informe-inasistencias-modal__content">
      <section className="informe-inasistencias-filtros">
        <div className="informe-inasistencias-filtros__encabezado">
          <div>
            <h5>Período de consulta</h5>

            <p>
              Por defecto se muestran los registros de los últimos 15 días.
            </p>
          </div>

          <span className="informe-inasistencias-filtros__cantidad">
            {ausenciasDocentes?.length || 0} registros
          </span>
        </div>

        <div className="informe-inasistencias-filtros__fechas">
          <div className="informe-inasistencias-filtros__campo">
            <label htmlFor="fechaInicioInforme">
              Fecha de inicio
            </label>

            <input
              type="date"
              id="fechaInicioInforme"
              className="form-control"
              value={fechaInicioInforme}
              max={fechaFinalInforme || undefined}
              onChange={(event) =>
                setFechaInicioInforme(event.target.value)
              }
            />
          </div>

          <div className="informe-inasistencias-filtros__campo">
            <label htmlFor="fechaFinalInforme">
              Fecha final
            </label>

            <input
              type="date"
              id="fechaFinalInforme"
              className="form-control"
              value={fechaFinalInforme}
              min={fechaInicioInforme || undefined}
              max={restaDias(-1)}
              onChange={(event) =>
                setFechaFinalInforme(event.target.value)
              }
            />
          </div>

          <button
            type="button"
            className="btn btn-primary informe-inasistencias-filtros__consultar"
            onClick={consultarInformeInasistencias}
          >
            Consultar
          </button>
        </div>

        <div className="informe-inasistencias-filtros__periodos">
          {periodosInasistencias.map((periodo) => (
            <button
              key={periodo.dias}
              type="button"
              className="btn btn-outline-warning"
              onClick={() =>
                consultarPeriodoInasistencias(periodo.dias)
              }
            >
              {periodo.texto}
            </button>
          ))}
        </div>
      </section>

      {Array.isArray(ausenciasDocentes) &&
      ausenciasDocentes.length > 0 ? (
        <ModuloDevuelveInasistenciasDocentes
          Docentes={ausenciasDocentes}
          refresco={() =>
            informaInasistencias(
              fechaInicioInforme || restaDias(15),
              fechaFinalInforme || restaDias(-1)
            )
          }
          myID={(campo) =>
            ordenoLasAusencias(ausenciasDocentes, campo)
          }
        />
      ) : (
        <div className="informe-inasistencias-vacio">
          <div className="informe-inasistencias-vacio__icono">
            ✓
          </div>

          <h4>No hay inasistencias para mostrar</h4>

          <p>
            Seleccione otro período o realice una nueva consulta.
          </p>
        </div>
      )}
    </div>
  </section>
</Modal>

      <Modal
        isOpen={modalDocentesIsOpen}
        onRequestClose={closeModalDocentes}
        style={{
          content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            transform: 'translate(-50%, -50%)',
            width: "90%",            // responsive ancho
            maxWidth: "900px",       // límite en desktop
            height: "700px",       // altura máxima
            overflow: "hidden",
            padding: "20px",
            borderRadius: "8px",
          },
        }}
        ariaHideApp={false}
      >
        {/* Header */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "15px",
            flexWrap: "wrap",
            borderBottom: "1px solid #ccc",
            paddingBottom: "10px",
          }}
        >
          <strong style={{ fontSize: "1rem", flexGrow: 1 }}>Gestión Cuerpo Docente</strong>
          <button
            className="btn btn-danger btn-sm"
            onClick={closeModalDocentes}
            style={{ lineHeight: "1", padding: "0 8px", marginTop: "5px" }}
          >
            ×
          </button>
        </div>

        {/* Buscador */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginBottom: "15px",
            width: "100%",
          }}
        >
          <div style={{ maxHeight: "200px", width: "100%" }}>
            <DocenteBuscadorGlobal
              devuelvo={(dato) => {

                consultaDocente(dato);
              }}
              criterio={"activo"}
            />
          </div>
          {docenteSeleccionado ? <button className="btn btn-warning" onClick={() => setDocenteSeleccionado(null)}>
            Limpiar
          </button> : <button className="btn btn-primary" onClick={() => definoCrear()}>
            Crear
          </button>
          }

        </div>

        {/* Contenido principal */}
        <div
          style={{
            overflowY: "auto",
            height: "550px",
            width: "100%",
            padding: "10px",
            border: "1px solid #ddd",
            borderRadius: "6px",
            backgroundColor: "#f9f9f9",
          }}
        >
          {/* Mostrar docente seleccionado */}
          {docenteSeleccionado && (
            <FormEditaDocente
              datos={docenteSeleccionado?.docente[0] || ""}
              myID={(x) => closeModalDocentes()}
            />
          )}






          {/* Formulario de creación */}
          {crearDocente && (
            <div style={{ marginTop: "15px" }}>
              <h4>Crear docente menu</h4>
              <FormEditaDocente datos={""} myID={() => closeModalDocentes()} />
            </div>
          )}
        </div>
      </Modal>


<Modal
  isOpen={modalHorasIsOpen}
  onRequestClose={closeModalHoras}
  className="modal-horas"
  overlayClassName="modal-horas-overlay"
  ariaHideApp={true}
>
  <div className="modal-horas-header">
    <button className="modal-horas-close" onClick={closeModalHoras}>x</button>
    <strong className="modal-horas-title">Gestión Horas Cátedras</strong>
  </div>

  <div className="modal-horas-body">
    <div className="modal-horas-container">

<div className="modal-horas-escuelas">
  {(
    Usuario.destino == 7 ||
    comprueboPermisos(
      Usuario.funcion,
      "Veo todas las escuelas Crear Cursos"
    )
  ) ? (
    <>
      <button
        className="mh-btn"
        onClick={() => seteaEscuela("Escuela de Policia")}
      >
        Escuela de Policía
      </button>

      <button
        className="mh-btn"
        onClick={() => seteaEscuela("Escuela de Investigaciones")}
      >
        Escuela de Investigaciones
      </button>

      <button
        className="mh-btn"
        onClick={() => seteaEscuela("Escuela Superior")}
      >
        Escuela Superior
      </button>

      <button
        className="mh-btn"
        onClick={() => seteaEscuela("Escuela de Especialidades")}
      >
        Escuela de Especialidades
      </button>

      <button
        className="mh-btn"
        onClick={() => seteaEscuela("Extension Comunitaria")}
      >
        Extensión Comunitaria
      </button>

      <button
        className="mh-btn"
        onClick={() => seteaEscuela("Educacion a Distancia")}
      >
        Educación a Distancia
      </button>

      <button
        className="mh-btn"
        onClick={() => seteaEscuela("Extracurricular")}
      >
        Extracurricular
      </button>
    </>
  ) : (
    <>
      {(
        Usuario.destino == 10 ||
        comprueboPermisos(
          Usuario.funcion,
          "Horas Extension Comunitaria"
        )
      ) && (
        <button
          className="mh-btn"
          onClick={() => seteaEscuela("Extension Comunitaria")}
        >
          Extensión Comunitaria
        </button>
      )}

      {(
        Usuario.destino == 15 ||
        comprueboPermisos(
          Usuario.funcion,
          "Horas Escuela de Investigaciones"
        )
      ) && (
        <button
          className="mh-btn"
          onClick={() => seteaEscuela("Escuela de Investigaciones")}
        >
          Escuela de Investigaciones
        </button>
      )}

      {(
        Usuario.destino == 14 ||
        comprueboPermisos(
          Usuario.funcion,
          "Horas Escuela de Especialidades"
        )
      ) && (
        <button
          className="mh-btn"
          onClick={() => seteaEscuela("Escuela de Especialidades")}
        >
          Escuela de Especialidades
        </button>
      )}

      {(
        Usuario.destino == 12 ||
        comprueboPermisos(
          Usuario.funcion,
          "Horas Escuela de Policia"
        )
      ) && (
        <button
          className="mh-btn"
          onClick={() => seteaEscuela("Escuela de Policia")}
        >
          Escuela de Policía
        </button>
      )}

      {(
        Usuario.destino == 11 ||
        comprueboPermisos(
          Usuario.funcion,
          "Horas Educacion a Distancia"
        )
      ) && (
        <button
          className="mh-btn"
          onClick={() => seteaEscuela("Educacion a Distancia")}
        >
          Educación a Distancia
        </button>
      )}

      {(
        Usuario.destino == 13 ||
        comprueboPermisos(
          Usuario.funcion,
          "Horas Escuela Superior"
        )
      ) && (
        <button
          className="mh-btn"
          onClick={() => seteaEscuela("Escuela Superior")}
        >
          Escuela Superior
        </button>
      )}
    </>
  )}
</div>

      {escuelaSeleccionada && (
        <div className="modal-horas-actions">

          {!mostrarCursos || !cursosSeteados?.Cursos?.length ? (
            <strong className="mh-empty">No hay cursos disponibles</strong>
          ) : null}

          <button className="mh-btn-primary" onClick={crearCurso}>Crear Curso</button>

          {mostrarCursos && cursosSeteados?.Cursos?.length > 0 && Usuario.destino==7 &&(
            <button className="mh-btn-secondary" onClick={abrirModalEditarCursos}>Editar Curso</button>
          )}

          {mostrarCursos && cursosSeteados?.Cursos?.length > 0 && (
            <button className="mh-btn-secondary" onClick={crearMaterias}>Crear Materias</button>
          )}

          {comprueboPermisos(Usuario.funcion, "Creo alulas moodle") && (
            <button className="mh-btn-secondary" onClick={crearAulasMoodle}>Crear Aulas Moodle</button>
          )}
        </div>
      )}

      <div className="modal-horas-content">
        {mostrarMateriasDevueltas && (
          <div className="mh-scroll">
            <DevuelveMaterias
              cosas={materiasDevueltas}
              cursos={cursosSeteados}
              myID={(value) => elijoDocente(value)}
            />
          </div>
        )}
      </div>

    </div>
  </div>
</Modal>

      <Modal
        isOpen={modalEditarCursosIsOpen}
        onRequestClose={cerrarModalListaCursos}
        style={customStylesGestion}
        ariaHideApp={false}
      >
        <ModalGestionHeader
          titulo="Editar curso"
          subtitulo={escuelaSeleccionada || "Seleccione un curso"}
          onClose={cerrarModalListaCursos}
        />

        <div style={{ padding: "16px" }}>
          {!mostrarCursos || !cursosSeteados?.Cursos?.length ? (
            <div
              style={{
                padding: "18px",
                border: "1px solid #ddd",
                borderRadius: "8px",
                background: "#f8f9fa",
                textAlign: "center",
              }}
            >
              <strong>No hay cursos activos para editar.</strong>
              <div style={{ fontSize: "12px", color: "#666", marginTop: "4px" }}>
                Primero cree un curso para esta escuela.
              </div>
            </div>
          ) : (
            <div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: "10px",
                  marginBottom: "10px",
                  flexWrap: "wrap",
                }}
              >
                <strong>Cursos disponibles</strong>
                <span style={{ fontSize: "12px", color: "#666" }}>
                  Total: {cursosSeteados?.Cursos?.length || 0}
                </span>
              </div>

              <div style={{ maxHeight: "65vh", overflow: "auto" }}>
                {(cursosSeteados?.Cursos || []).map((curso) => (
                  <div
                    key={curso.id}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      padding: "10px",
                      border: "1px solid #e5e5e5",
                      borderRadius: "8px",
                      marginBottom: "8px",
                      gap: "10px",
                      background: "#fff",
                    }}
                  >
                    <div>
                      <strong>
                        {curso.nombreCurso || curso.nombre || `Curso ID ${curso.id}`}
                      </strong>
                      <div style={{ fontSize: "12px", color: "#666" }}>
                        {curso.sede ? `Sede: ${curso.sede}` : ""}
                        {curso.fechaInicio ? ` · Inicio: ${curso.fechaInicio}` : ""}
                        {curso.fechaFinalizacion ? ` · Fin: ${curso.fechaFinalizacion}` : ""}
                      </div>
                    </div>

                    <button
                      className="btn btn-warning btn-sm"
                      onClick={() => editarCurso(curso)}
                    >
                      Editar
                    </button>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </Modal>

      <Modal
        isOpen={mostrarEditaCurso}
        onRequestClose={cerrarModalCurso}
        style={customStylesGestion}
        ariaHideApp={false}
      >
        <ModalGestionHeader
          titulo={modoCurso === "editar" ? "Editar curso" : "Crear curso"}
          subtitulo={escuelaSeleccionada || cursoSeleccionado?.escuela || ""}
          onClose={cerrarModalCurso}
        />

        <div style={{ padding: "16px" }}>
          <FormEditaCurso
            modo={modoCurso}
            Datos={
              modoCurso === "editar"
                ? cursoSeleccionado
                : { escuela: escuelaSeleccionada }
            }
            cas={(escuelaDevuelta) => refrescarGestionEscuela(escuelaDevuelta)}
            onGuardado={() => refrescarGestionEscuela(escuelaSeleccionada)}
          />
        </div>
      </Modal>

      <Modal
        isOpen={mostrarEditaMateria}
        onRequestClose={cerrarModalMateria}
        style={customStylesGestion}
        ariaHideApp={false}
      >
        <ModalGestionHeader
          titulo="Crear materias"
          subtitulo={escuelaSeleccionada || ""}
          onClose={cerrarModalMateria}
        />

        <div style={{ padding: "16px" }}>
          <FormEditaMateria
            Datos={escuelaSeleccionada}
            Cursos={cursosSeteados}
            cas={(escuelaDevuelta) => refrescarGestionEscuela(escuelaDevuelta)}
            onGuardado={() => refrescarGestionEscuela(escuelaSeleccionada)}
          />
        </div>
      </Modal>

      <Modal
        isOpen={mostrarMoodle}
        onRequestClose={cerrarModalMoodle}
        style={customStylesGestion}
        ariaHideApp={false}
      >
        <ModalGestionHeader
          titulo="Crear aulas Moodle"
          subtitulo={escuelaSeleccionada || ""}
          onClose={cerrarModalMoodle}
        />

        <div style={{ padding: "16px" }}>
          <SincronizaMoodle
            Datos={escuelaSeleccionada}
            Cursos={cursosSeteados}
            cas={(escuelaDevuelta) => refrescarGestionEscuela(escuelaDevuelta)}
            onGuardado={() => refrescarGestionEscuela(escuelaSeleccionada)}
          />
        </div>
      </Modal>



      <div className="docentesConteiner">
        <h1 className="tituloDocentes">Menú de Gestión de Docentes y Horas Cátedras</h1>

        <div className="btn-groupSalir">
          <button className="btn btn-warning" onClick={volver}>Volver</button>
        </div>

      </div>
      <div className="botonesConteiner">

        {Usuario.destino == "1" || Usuario.destino == "45" || Usuario.destino == "7" || Usuario.destino >= "10" && Usuario.destino < "20" || Usuario.destino == "25" || Usuario.destino == "26" || Usuario.destino == "27" || Usuario.destino == "28" || Usuario.destino == "34" || Usuario.destino == "56" || comprueboPermisos(Usuario.funcion, "Veo inasistencia docente") ? <>
          <button className="button-18" onClick={informaInasistencias}>Informe Inasistencias Docentes</button></>
          : ""}
        {Usuario.destino == "7" || comprueboPermisos(Usuario.funcion, "Gestiona Docentes") ? <>
          <button className="button-18" onClick={() => setDocentesIsOpen(true)}>Gestión Docentes</button>
         </> : ""}
        <button className="button-18" onClick={openModalInformeDocente}>Informe Horas Docentes</button>
     
        <button className="button-18" onClick={() => setHorasIsOpen(true)}>Gestión Horas catédras e Inasistencias</button>
        {comprueboPermisos(Usuario.funcion, "Busco Docentes") ? <button className="button-18" onClick={() => navitate('/DocenteBuscador')}>Buscar Docente</button> : ""}
        
        {Usuario.destino == "7" || comprueboPermisos(Usuario.funcion, "Veo Avisos docente") ? <>
          <button className="button-18" onClick={() => setVeoModalAvisos(true)}>Avisos Docentes</button></>
          : ""}
        {Usuario.destino == "7" || comprueboPermisos(Usuario.funcion, "Veo Informe Avisos docente") ? <>
          <button className="button-18" onClick={funcionMauri}>Informe Avisos Docentes</button></>
          : ""}

          {Usuario.destino == "7" || comprueboPermisos(Usuario.funcion, "Crea Incumbencia") ? (
  <>
    <button
      className="button-18"
      onClick={() => setVeoModalCreaIncunvencia(true)}
    >
      Crea Incumbencia
    </button>
  </>
) : ""}

 { comprueboPermisos(Usuario.funcion, "Veo Control Qr") ? <> <button className="button-18" onClick={() => navitate('/reporteAsistenciaDocentes')}>Control QR</button></>:""}
        { comprueboPermisos(Usuario.funcion, "Informe Docentes Plataforma") ? <> <button className="button-18" onClick={() => navitate('/DocentePlataforma')}>Informe Docentes Plataforma</button></>:""}
 { comprueboPermisos(Usuario.funcion, "Veo Planillas Sarh") ? <> <button className="button-18" onClick={() => navitate('/AsignacionesSarh')}>Informe Planillas Sarh</button></>:""}
{ comprueboPermisos(Usuario.funcion, "Veo Informe Incumbencias") ? <> <button className="button-18" onClick={() => navitate('/ReporteIncumbenciaDisponibilidad')}>Reporte de Incumbencias y Disponibilidad</button></>:""}



      </div>
      <div className="usuarioConteiner">
        <div className="h3Conten">
          <h3>
            Usuario logueado: {Usuario?.nombre || ""} {Usuario?.apellido || ""} de{" "}
            {descripcionDependencia}
          </h3>
        </div>
      </div>

      {veoModalMauri ? <>

<Modal
  isOpen={veoModalMauri}
  onRequestClose={() => setVeoModalMauri(false)}
  style={customStylesMauri}
  ariaHideApp={false}
  contentLabel="Informe estadístico de ausencias docentes"
>
  <InformeAusenciasDocentes
    onClose={() => setVeoModalMauri(false)}
  />
</Modal>







      </> : ""}

      {veoModalAvisos ? <>

<Modal
  isOpen={veoModalAvisos}
  onRequestClose={() => setVeoModalAvisos(false)}
  style={customStylesMauri}
  ariaHideApp={false}
  contentLabel="Avisos de ausencias docentes"
>
  <ModuloAvisosAusenciasDocentes
  />
</Modal>







      </> : ""}

{veoModalCreaIncunvencia ? (
  <Modal
    isOpen={veoModalCreaIncunvencia}
    onRequestClose={() =>
      setVeoModalCreaIncunvencia(false)
    }
    style={customStylesMauri}
    ariaHideApp={false}
    contentLabel="Crear Incumbencia Docentes"
  >
    <ModuloCreaIncunvenciaDocentes
      cerrarModal={() =>
        setVeoModalCreaIncunvencia(false)
      }
    />
  </Modal>
) : ""}

      {veoModalSeleccionDocente ? <>

        <ModalNew
          isOpen={veoModalSeleccionDocente}
          onRequestClose={() => setVeoModalSeleccionDocente(false)}
          style={customStyles}
          ariaHideApp={false}
          onClose={() => setVeoModalSeleccionDocente(false)}
        >

          <>
            <div style={{ width: "auto", height: "400px", display: "flex", alignItems: "center", overflow: "auto", flexDirection: "column" }}>
              <h5>Seleccione el docente</h5>
              <div>
                <DocentesPorMateriaTablaAsignacion nombreMateria={datosMateriaElegida} devuelvo={(f) => {
                  ahoraVerifico(f)

                }} />
              </div>

            </div>
          </>
        </ModalNew>








      </> : ""}

      {veoModalSeleccionDivisiones ? <>

        <ModalNew
          isOpen={veoModalSeleccionDivisiones}
          onRequestClose={() => setveoModalSeleccionDivisiones(false)}
          style={customStyles}
          ariaHideApp={false}
          onClose={() => setveoModalSeleccionDivisiones(false)}
        >

          <>
            <div style={{ width: "600px", height: "550px", display: "flex", alignItems: "center", overflow: "auto", flexDirection: "column" }}>

              <div>
                <DivisionesSelector divisiones={divisionesElegidas} docente={docenteObtenidoModal} asigna={(a) => asignaHoras(a)} />
              </div>

            </div>
          </>
        </ModalNew>








      </> : ""}

    </div>
  );
}
export default Docentes